<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="商品名称">
        <el-input v-model="searchForm.prodName" placeholder="商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品ID">
        <el-input v-model="searchForm.productId" placeholder="商品ID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="productId" label="商品ID" align="center"></el-table-column>
      <el-table-column label="商品图片" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 60px; height: 60px;"
            :src="scope.row.coverPhoto"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
      <el-table-column prop="price" label="价格" align="center"></el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px;"
    ></el-pagination>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryProduct } from '@/api/goods/recommendGoodsApi'

export default {
  name: 'ChooseLabelProduct',
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        prodName: '',
        productId: '',
        labelCd: ''
      },
      tableData: [],
      multipleSelection: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open(params) {
      this.searchForm.labelCd = params.labelCd
      this.dialogVisible = true
      this.getProductList()
    },
    
    async getProductList() {
      try {
        const res = await queryProduct({
          ...this.searchForm,
          page: this.currentPage,
          row: this.pageSize,
          hasProduct: 'N'
        })
        this.tableData = res.data
        this.total = res.total
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },

    onSearch() {
      this.currentPage = 1
      this.getProductList()
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getProductList()
    },

    handleConfirm() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      this.$emit('chooseLabelProduct', this.multipleSelection[0])
      this.dialogVisible = false
    },

    handleClose() {
      this.searchForm.prodName = ''
      this.searchForm.productId = ''
      this.multipleSelection = []
    }
  }
}
</script>